import React from "react";
import { Box, styled } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { colors, fontWeight } from "theme/defaultStyle";

const Banner = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginBottom: 12,
  padding: "6px 12px",
  fontSize: 12,
  color: colors.blue31,
  backgroundColor: colors.blue29,
  border: `1px solid ${colors.blue30}`,
  borderRadius: 4,
  "& .MuiSvgIcon-root": { fontSize: 16, color: colors.blue15 },
  "& strong": { fontWeight: fontWeight.bold1 },
  "& .gs-banner-clear": {
    marginLeft: "auto",
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    fontSize: 12,
    fontWeight: fontWeight.bold1,
    color: colors.blue15,
    whiteSpace: "nowrap",
    "&:hover": { textDecoration: "underline" },
  },
});

type Props = {
  label: string;
  onClear: () => void;
};

// Shown above a queue that was opened from Global Search.
const GlobalSearchFilterBanner = ({ label, onClear }: Props) => (
  <Banner role="status">
    <InfoOutlinedIcon />
    <span>
      Filtered by global search: <strong>{label}</strong>
    </span>
    <button type="button" className="gs-banner-clear" onClick={onClear}>
      Clear filter
    </button>
  </Banner>
);

export default GlobalSearchFilterBanner;
